import "./Slide.css";

import { VerifiedTooltip } from "../CustomCheckTooltips/CustomCheckTooltips";
import { baseURL } from "../../../api/dataFetcher";
import VideoCard from "../VideoCard/VideoCard";

export default function Slide({
  href,
  imgSrc,
  imgAlt = "",
  label,
  views,
  verified = null,
  style,
  type = "channel",
  videoCover,
  videoTitle,
  videoCategory,
  videoCountedViews,
  videoPublishedDate,
  viedoChannelName,
  videoChannelId,
  videoId,
}) {
  const verifyLabel = verified ? <VerifiedTooltip /> : "";

  return (
    <>
      {type === "channel" ? (
        <div className="item">
          <div className="category-item">
            <a href={href ? href : "#"}>
              <img
                style={{ objectFit: "cover" }}
                className="img-fluid custom-slick-img"
                src={imgSrc ? baseURL + imgSrc : "/img/s1.png"}
                alt={imgAlt}
              />
              <h6>
                {label} {verifyLabel}
              </h6>
              <p> {views} بازدید</p>
            </a>
          </div>
        </div>
      ) : (
        <div className="item" style={{ height: "100%" }}>
          <VideoCard
            imgSrc={videoCover}
            videoTitle={videoTitle}
            videoCategory={videoCategory}
            views={videoCountedViews}
            timeAgo={videoPublishedDate}
            verified
            channelName={viedoChannelName}
            channelId={videoChannelId}
            imgHref={`/special-video-page/${videoId}/`}
            iconHref={`/special-video-page/${videoId}/`}
            videoTitleHref={`/special-video-page/${videoId}/`}
          />
        </div>
      )}
    </>
  );
}
